import Vue from 'vue'

import { VueMaskFilter } from 'v-mask'
Vue.filter('VMask', VueMaskFilter)
